const EventsView = () => {
  return <div>EventsView</div>;
};

export default EventsView;
